<script setup lang="ts">
import LoggedIn from "./LoggedIn.vue";
</script>
<template>
  <LoggedIn v-slot="{ me }">
    <main><slot :me="me" /></main>
  </LoggedIn>
</template>
